import component from './en-US/component';
import globalHeader from './en-US/globalHeader';
import menu from './en-US/menu';
import pages from './en-US/pages';
import indexPage from './en-US/indexPage';
import login from './en-US/login';
import register from './en-US/register';
import forgotPassword from './en-US/forgotPassword';
import authError from './en-US/authError';
import ai from './en-US/ai';
import assets from './en-US/assets';
import memberAsset from './en-US/memberAsset';
import creativeVideo from './en-US/creativeVideo';
import creativeImage from './en-US/creativeImage';
import pwa from './en-US/pwa';
import settingDrawer from './en-US/settingDrawer';
import settings from './en-US/settings';

export default {
  /** 顶栏「语言」切换文案（与 zh-CN 的 navBar.lang 成对） */
  'navBar.lang': 'Language',
  'layout.user.link.help': 'Help',
  'layout.user.link.privacy': 'Privacy',
  'layout.user.link.terms': 'Terms',
  'app.preview.down.block': 'Download this page to your local project',
  'app.welcome.link.fetch-blocks': 'Get all block',
  'app.welcome.link.block-list':
    'Quickly build standard, pages based on `block` development',
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...pages,
  ...indexPage,
  ...login,
  ...register,
  ...forgotPassword,
  ...authError,
  ...ai,
  ...assets,
  ...memberAsset,
  ...creativeVideo,
  ...creativeImage,
};
